// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"208":"invalid","420":"message","594":"about","772":"cookies"}[chunkId] + "." + {"208":"04250971","420":"90ae8071","594":"a4e93728","772":"38e41f5a"}[chunkId] + ".js";
};